import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import {DeleteSuggestion, GetSuggestions} from "../../services/suggestions.service";
import {constants, customStyles, STATUS} from "../../utils/constants";
import moment from "moment";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import swal from "sweetalert";
import {Button, Col, Dropdown, DropdownButton, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {AddIconOutline, MenuDots, SearchIcon} from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";
import {DeleteProduct, GetProduct} from "../../services/product.service";
import {GetCategory} from "../../services/category.service";
import Select from "react-select";
import ImagePreview from "../../components/ImagePreview";

function Product(props) {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [selectedCategory, setSelectedCategory] = useState();
    const [categoryValue, setCategoryValue] = useState();
    const [category, setCategory] = useState([]);
    const typingTimeoutRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');




    useEffect(async () => {
        getCategory();
        getProduct();
        window.scrollTo(0, 0);
    }, [keyword, page, perPage,selectedCategory,status])



    const getProduct = async () => {
        setLoading(true)
        await GetProduct(keyword, page, perPage,1,status,selectedCategory).then((result) => {
            if (result.status) {
                if (result.data.products) {
                    const rowData = [];
                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result.data.pagination.total);
                    result.data.products.map((dt, index) => {
                        rowData.push({
                            id:dt._id || '-',
                            title: dt.title || '-',
                            image: dt?.attachments && dt?.attachments.length > 0 ? dt?.attachments[0]?.path : null,
                            category_id:dt?.category[0]?.name || '-',
                            description:dt.description || '-',
                            price: dt.price || '-',
                            discounted_price: dt.discounted_price || '-',
                            qq_composition: dt.qq_composition || '-',
                            pharmaceutical_form: dt.pharmaceutical_form || '-',
                            sku: dt.sku || '-',
                            tablet_core: dt.tablet_core || '-',
                            tablet_coating: dt.tablet_coating || '-',
                            incompatiblities: dt.incompatiblities || '-',
                            shelf_life: dt.shelf_life || '-',
                            special_precautions_for_storage: dt.special_precautions_for_storage || '-',
                            manufacturer: dt.manufacturer || '-',
                            active_ingredient: dt.active_ingredient || '-',
                            tags: dt.tags || '-',
                            status: STATUS[dt?.status],
                            created_at: moment(dt.created_at).fromNow(),
                            updated_at: (dt?.updated_at ? moment(dt?.updated_at).fromNow() : '-')

                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else if(error.response.status == 404) {
                setRows([]);
            }else {
                return toast.error(error.response.data.message);
            }
        })
    }


    const onProductDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this Product?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {

            if (willShip) {
                await DeleteProduct(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getProduct();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status == 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {

                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        history.push(`/products/edit-product/` + data.id, {
            data: data
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onEdit(data)}>Edit</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onProductDelete(data.id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }
    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const columns = [
        {
            id: 'id',
            name: 'Id',
            sortable: true,
            selector: rowData => rowData.id,
        },
        {
            id: 'image',
            name: 'Image',
            selector: rowData => rowData.image,
            format: rowData => <img src={rowData.image}
                                    onClick={() => handleImageClick(rowData.image)}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = constants.IMAGENOTFOUND;
                                    }}
                                    alt={'Broken'}
                                    className={"img-table img-thumbnail"} crossOrigin={"anonymous"} />
        },
        {
            id: 'title',
            name: 'Title',
            grow: false,
            center: true,
            sortable: true,
            selector: rowData => rowData.title,
        },
        {
            id: 'category_id',
            name: 'Category',
            grow: false,
            center: true,
            selector: rowData => rowData.category_id,
        },
        {
            id: 'description',
            name: 'Description',
            grow: false,
            maxWidth:'300px',
            selector: rowData => rowData.description,
        },
        {
            id: 'price',
            name: 'Price ($)',
            grow: false,
            center: true,
            sortable: true,
            selector: rowData => rowData.price,
        },
        // {
        //     id: 'discounted_price',
        //     name: 'Discounted Price',
        //     grow: false,
        //     center: true,
        //     minWidth:'150px',
        //     sortable: true,
        //     selector: rowData => rowData.discounted_price,
        // },
        {
            id: 'manufacturer',
            name: 'Manufacturer',
            grow: false,
            width:'150px',
            center: true,
            sortable: true,
            selector: rowData => rowData.manufacturer,
        },
        {
            id: ' status',
            name: 'Status',
            grow: false,
            center: true,
            selector: rowData => rowData.status,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
        },
        {
            id: 'updated_at',
            name: 'Updated At',
            grow: false,
            center: true,
            selector: rowData => rowData.updated_at,
        },
        {
            id: 'action',
            name: 'Action',
            cell: rowData => userActions(rowData)
        },
    ];

    const getCategory = async () => {
        await GetCategory(null, null, null, 0, true,'Product').then((result) => {
            if (result.status && result.data) {
                result.data.unshift({name:'All', _id:null })
                setCategory(result.data);
            }
        })
    }

    const optionsCategory = (item) => {
        setCategoryValue({label:item.label ,value:item.value})
        setSelectedCategory(item.value);
    }

    const filterStatus = async (value) => {
        setStatus(value)

    }

    const handleKeyUp = (e) => {
        clearTimeout(typingTimeoutRef.current);

        const value = e.target.value;
        if (value.length > 2) {
            typingTimeoutRef.current = setTimeout(() => {
                setKeyword(value);
            }, 500); // Set keyword after 500 milliseconds of inactivity
        } else {
            setKeyword(null);
        }
    };

    return (
        <div className={"productPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Products</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onKeyUp={handleKeyUp}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}>

                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Link to={"/products/add-product"}>
                            <Button className={"btn btn-green-theme h40 w-100 mb-md-0 mb-sm-3 mb-3"}>
                                <AddIconOutline /> Add New
                            </Button>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col  xs={12} sm={6} md={4} lg={3} xl={3}>
                        <Form.Group className={"mb-3"} controlId="status">
                            <Form.Select className='formselect' aria-label="status"
                                         onChange={(e) => filterStatus(e.target.value)}
                                         value={status}
                            >
                                <option selected disabled value="" >Filter Status</option>
                                <option value={""}>All</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={5} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="category">
                            <Select
                                value={categoryValue}
                                placeholder={'Filter category'}
                                options={category && category?.map(e => ({ label: e.name, value:e._id }))}
                                className="basic-multi-select"
                                onChange={optionsCategory}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={3} md={{ span: 3, offset: 0 }} lg={{ span: 3, offset: 2}} xl={{ span: 2, offset: 4 }}>
                        <Button className={"btn btn-filter-theme h40 w-100"} onClick={()=>{
                            setStatus('')
                            setCategoryValue(null)
                            setSelectedCategory(null)

                        }}>
                            Reset Filters
                        </Button>
                    </Col>
                </Row>
            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    columns={columns}
                    data={rows}
                    // actions={actionsMemo}
                    // data={data}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);


                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                                                  height={'4'} width={'100%'} />}
                />
            </div>
            <ImagePreview
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                content={selectedImage}
            />
        </div>
    );
}

export default Product;